import React, { useState, useRef, useEffect } from "react";
import { GlyphButton } from "../Button/GlyphButton";
import { ReactComponent as ImageEdit } from '../../../public/images/svg/ImageEdit.svg'
import { ReactComponent as ImageSave } from '../../../public/images/svg/ImageSave.svg';
import { ReactComponent as ImageCancel } from '../../../public/images/svg/ImageCancel.svg';
import "./css/TextInput.css";

export interface TextInputProps {
    value: string;
    onSave: (newValue: string) => void;
    onCancel?: () => void;
    isEnabled?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

export const TextInput: React.FC<TextInputProps> = ({
    value,
    onSave,
    onCancel,
    isEnabled = true,
    className,
    style,
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [draft, setDraft] = useState(value);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.setSelectionRange(draft.length, draft.length);
        }
    }, [isEditing, draft]);

    const handleEditClick = () => {
        setDraft(value);
        setIsEditing(true);
    };

    const handleSaveClick = () => {
        onSave(draft);
        setIsEditing(false);
    };

    const handleCancelClick = () => {
        setIsEditing(false);
        onCancel?.();
    };

    return (
        <div className={`text-edit-box ${isEditing ? "editing" : ""} ${className ?? ""}`} style={style}>
            <input ref={inputRef}
                type="text"
                value={isEditing ? draft : value}
                onChange={(e) => setDraft(e.target.value)}
                readOnly={!isEditing}
                className="text-edit-input" />

            {!isEditing
                ? <GlyphButton ariaLabel="edit"
                    IconComponent={<ImageEdit />}
                    className="text-edit-button"
                    disabled={!isEnabled}
                    onClick={handleEditClick} />
                : <div className="text-edit-button-group">
                    <GlyphButton ariaLabel="save"
                        IconComponent={<ImageSave width={16} height={16} />}
                        className="text-edit-button save-text-input"
                        onClick={handleSaveClick} />
                    <GlyphButton ariaLabel="cancel"
                        IconComponent={<ImageCancel />}
                        className="text-edit-button cancel-text-input"
                        onClick={handleCancelClick} />
                </div>
            }
        </div>
    );
};

export default TextInput;
